// Auto-generated from 王凤麟疾病象意.md
// Source: /Users/xiaodongliu/Downloads/轩书房/1-输入/3-专题笔记/国学/1-符号象意/王凤麟疾病象意.md
// Entries: 638

export type PalaceDiseaseComboMap = Record<string, Record<string, string>>;

export const PALACE_DISEASE_COMBO_MAP: PalaceDiseaseComboMap = {
  "乾": {
    "丙+丙": "代表脚后跟有炎症。",
    "丙+丁": "代表脚踝骨或脚后跟有骨刺或炎症。",
    "丙+庚": "代表脚踝骨骨折。",
    "丙+癸": "代表脚踝骨或脚跟发麻发凉。",
    "丙+己": "代表脚后跟有脚垫或皮质增厚。",
    "丙+壬": "代表脚踝骨或脚根酸胀。",
    "丙+戊": "代表脚踝骨肥大或腿肚子大。",
    "丙+辛": "代表脚踝骨有脚垫或皮皲裂。",
    "丙+乙": "代表脚踝骨或脚后跟酸痛。",
    "丁+丙": "代表脚趾有炎症或痒痛。",
    "丁+丁": "代表脚气或脚气或指甲有问题。",
    "丁+庚": "代表脚趾有折断的信息。",
    "丁+癸": "代表脚趾流脓或发炎。",
    "丁+己": "代表脚趾不干净，长了多余的东西。",
    "丁+壬": "代表脚趾发胀或流血。",
    "丁+戊": "代表脚趾肿胀或发麻。",
    "丁+辛": "代表脚趾有增生、骨刺的信息。",
    "丁+乙": "代表脚趾弯曲或酸痛。",
    "癸+丙": "代表足部有炎症。",
    "癸+丁": "代表足部有鸡眼或足部被扎、叮咬。",
    "癸+庚": "代表足部受伤或骨折。",
    "癸+癸": "代表足部有脚气或疮或湿疹的信息。",
    "癸+己": "代表足部长瘤或者多余的肉。",
    "癸+壬": "代表足部有水肿或发胀的信息。",
    "癸+戊": "代表足部麻木。",
    "癸+辛": "代表足部错位或足骨有伤的信息。",
    "癸+乙": "代表足部酸胀。",
    "己+丙": "代表跟腱痒痛或发炎。",
    "己+丁": "代表跟腱部有炎症或受伤。",
    "己+庚": "代表跟腱部位萎缩或受伤。",
    "己+癸": "代表跟腱部位感染。",
    "己+己": "代表跟腱有瘤。",
    "己+壬": "代表跟腱部位胀痛。",
    "己+戊": "代表跟腱发麻痛。",
    "己+辛": "代表跟腱部位受伤或做手术。",
    "己+乙": "代表跟腱酸痛。",
    "壬+丙": "代表胫骨炎症或血管炎。",
    "壬+丁": "代表胫骨有炎症或有卡子。",
    "壬+庚": "代表胫骨骨折或小腿血管变异。",
    "壬+癸": "代表胫骨骨髓炎或血管炎。",
    "壬+己": "代表胫骨疏松，或血管瘤。",
    "壬+壬": "代表胫骨有炎症。",
    "壬+戊": "代表胫骨骨髓变异；小腿部血管壁增厚。",
    "壬+辛": "代表小腿骨裂或骨折。",
    "壬+乙": "代表胫骨弯曲、腿血管曲张。",
    "戊+丙": "代表腿肚子发炎或流血。",
    "戊+丁": "代表腿肚子被叮咬扎伤或流血手术。",
    "戊+庚": "代表腿肚子肌肉萎缩。",
    "戊+癸": "代表腿肚子长疮流脓或湿疹。",
    "戊+己": "代表腿肚子长瘤、或多余的肉。",
    "戊+壬": "代表腿肚子流血或胀痛。",
    "戊+戊": "代表腿肚子肿胀。",
    "戊+辛": "代表腿肚子有颗粒状物质。",
    "戊+乙": "代表腿肚子酸痛。",
    "辛+丙": "代表膝盖有炎症。",
    "辛+丁": "代表膝盖部位长了骨刺，或有炎症。",
    "辛+庚": "代表膝盖部位脱臼、断裂。",
    "辛+癸": "代表膝盖部位有湿疹或积液、脓血。",
    "辛+己": "代表膝盖部位有硬块。",
    "辛+壬": "代表膝盖部位有积液。",
    "辛+戊": "代表膝盖部位肿胀。",
    "辛+辛": "代表髌骨增生。",
    "辛+乙": "代表膝盖有风湿或酸痛。",
    "乙+丙": "表示腿部有炎症；或烧伤、烫伤等。",
    "乙+丁": "代表腿部有炎症；被锐器割伤或扎伤；被动物咬伤、叮伤；烧伤烫伤等。",
    "乙+庚": "代表腿部得了硬皮病、牛皮癣等；肌肉坏死；或断腿。",
    "乙+癸": "代表腿部有湿疹、皮炎、疮、流脓血、或血管的血有栓塞信息等。",
    "乙+己": "代表腿部或脚步长有疙瘩或瘤子，腿部血管有血栓等。",
    "乙+壬": "代表腿部流过血；腿部血管曲张。",
    "乙+戊": "代表腿部浮肿；血管有增生物等。",
    "乙+辛": "代表腿部有颗粒状物；或断过腿；或血管神经有变异。",
    "乙+乙": "代表腿部血管或神经相缠；或腿部受风；腿部弯曲，不能伸直。"
  },
  "坎": {
    "丙+丙": "代表外生殖器有炎症或红肿、瘙痒，女性有经血。",
    "丙+丁": "代表外生殖器有湿疣等增生物或手术。",
    "丙+庚": "代表外生殖器有藓类疾病或萎缩。",
    "丙+癸": "代表外阴溃烂或外阴胀痛。",
    "丙+己": "代表外生殖器有增生物或分泌物。",
    "丙+壬": "代表外生殖器常有汗液等分泌物。",
    "丙+戊": "代表外生殖器失去知觉或肥大。",
    "丙+辛": "代表外生殖器有湿疹等颗粒状物。",
    "丙+乙": "代表外生殖器畸形、外观不正常。",
    "丁+丙": "代表男女外阴红肿刺痒。",
    "丁+丁": "代表男女外阴湿疣、增生、刺痒。",
    "丁+庚": "代表外阴痿缩或有硬皮症或外阴白斑。",
    "丁+癸": "代表男性遗精盗汗、女性淫液横流、经血。",
    "丁+己": "代表外阴不洁或有增生物。",
    "丁+壬": "代表外阴潮湿、大小便失禁。",
    "丁+戊": "代表女性外阴麻胀、肥厚。",
    "丁+辛": "代表外阴部有湿疹等颗粒状物。",
    "丁+乙": "代表男性阳萎、女性冷阴、性冷淡。",
    "庚+丙": "代表骨盆炎或直肠炎。",
    "庚+丁": "代表骨盆、大肠有炎症或手术。",
    "庚+庚": "代表骨盆骨折或便秘。",
    "庚+癸": "代表骨盆错位或直肠便脓便血等。",
    "庚+己": "代表骨盆位置有瘤或骨质增生，大肠息肉。",
    "庚+壬": "代表骨盆错位、直肠流血等。",
    "庚+戊": "代表骨盆大肠失去知觉或直肠息肉。",
    "庚+辛": "代表骨盆骨质增生或直肠息肉等。",
    "庚+乙": "代表盆骨不正、直肠弯曲。",
    "癸+丙": "代表肾炎，尿道炎、\\*\\*炎、睾丸炎等。",
    "癸+丁": "代表肾炎、尿路感染、结石，睾丸炎等。",
    "癸+庚": "代表肾结石，肾衰竭，尿道不通等。",
    "癸+癸": "代表肾炎、睾丸炎，尿路感染等。",
    "癸+己": "代表肾囊肿，\\*\\*尿道感染，睾丸炎。",
    "癸+壬": "代表肾积水，睾丸积水，尿频，尿多。",
    "癸+戊": "代表肾囊肿，睾丸肿大等。",
    "癸+辛": "代表肾结石，尿路结石，尿路感染手术等。",
    "癸+乙": "代表尿道狭窄、\\*\\*不直，排尿不畅，肾功能衰弱。",
    "己+丙": "代表前列腺炎，肛门痔疮红肿、龟头阴唇发炎。",
    "己+丁": "代表前列腺疾病，小阴唇、肛门部位有炎症。",
    "己+庚": "代表便秘、龟头、小阴唇部位息肉或有不洁物。",
    "己+癸": "代表龟头流脓、肛门痔疮、或小阴唇部有疮、溃疡等。",
    "己+己": "代表代表肛门、龟头、小阴唇部位息肉或有不洁物。",
    "己+壬": "代表肛门流血。",
    "己+戊": "代表肛门息肉或龟头、小阴唇部位麻痛或失去知觉。",
    "己+辛": "代表肛门、龟头、小阴唇部位有颗粒状物或手术。",
    "己+乙": "代表前列腺部位狭窄，直肠弯曲、龟头小、阴唇酸痛不适。",
    "壬+丙": "代表膀胱炎，尿血，子宫出血及炎症。",
    "壬+丁": "代表膀胱炎，尿血，子宫出血或手术。",
    "壬+庚": "代表尿潴留、膀胱癌、子宫癌或不孕等。",
    "壬+癸": "代表膀胱肿胀、尿血、子宫出血、宫颈糜烂。",
    "壬+己": "代表子宫后倾、子宫肌瘤，膀胱炎，子宫肌瘤或囊肿。",
    "壬+壬": "代表子宫脱垂、子宫出血，膀胱肿胀等。",
    "壬+戊": "代表膀胱炎，子宫肌瘤。",
    "壬+辛": "代表膀胱手术、排尿不通，宫颈糜烂，手术等。",
    "壬+乙": "代表子宫前倾，排尿不畅。",
    "戊+丙": "代表腹股沟部炎症或瘙痒。",
    "戊+丁": "代表腹股沟部为手术或刺痒或红肿。",
    "戊+庚": "代表腹股沟部位有藓、白斑等。",
    "戊+癸": "代表腹股沟部位有湿疹或疮等。",
    "戊+己": "代表腹股沟部为有增生物或瘤或不干净。",
    "戊+壬": "代表腹股沟部位有黑斑、肿胀等。",
    "戊+戊": "代表腹股沟部为肥厚或失去知觉等。",
    "戊+辛": "代表腹股沟部位有湿疹等颗粒状物质或手术。",
    "戊+乙": "代表腹股沟部为酸胀不适。",
    "辛+丙": "代表睾丸炎或腰椎发炎。",
    "辛+丁": "代表睾丸炎或腰椎增生、手术。",
    "辛+庚": "代表睾丸癌变或腰椎骨折。",
    "辛+癸": "代表睾丸湿疹或炎症，腰椎错位或炎症。",
    "辛+己": "代表睾丸长疮或腰椎增生。",
    "辛+壬": "代表睾丸肿大或腰椎错位。",
    "辛+戊": "代表睾丸肥大，腰椎增生或麻木。",
    "辛+辛": "代表睾丸手术或腰椎增生手术。",
    "辛+乙": "代表腰椎弯曲。",
    "乙+丙": "代表尿血、炎症；男性代表阴茎或输精管有炎症；女性代表**炎、卵巢或输卵管有炎症。",
    "乙+丁": "代表尿血、炎症；男性代表阴茎生丁（性病）；女性代表妇科病。",
    "乙+庚": "代表输卵管、输精管等硬化、堵赛、病变。",
    "乙+癸": "代表女性**内有白带、经血、或感染、溃烂，男性小便滴浊、阴茎上感染溃烂。",
    "乙+己": "代表生殖器上有脏东西如白带、白色念珠菌等。",
    "乙+壬": "代表女性怀孕或月经不调、经水过多，男性尿床、小便次数多。",
    "乙+戊": "代表男性生殖器麻疼或前列腺增生；女性代表**、卵巢、输卵管瘤。",
    "乙+辛": "代表输卵管、输精管等做过手术或有小型瘤。",
    "乙+乙": "代表男性代表阳痿，输精管狭窄或阻塞；女性代表**不直，输卵管狭窄或阻塞。"
  },
  "艮": {
    "丙+丙": "代表背部有肿块、炎症，小肠炎症。",
    "丙+丁": "代表背部有炎症，有肿胞、肠炎。",
    "丙+庚": "代表背部疼痛、白斑、皮肤病，小肠恶性病。",
    "丙+癸": "代表背部溃烂，小肠炎症。",
    "丙+己": "代表背部有疮或瘤、疙瘩，肠炎。",
    "丙+壬": "代表背部有斑痣或溃烂，小肠炎症。",
    "丙+戊": "代表背部赘肉，背部麻痛，肠梗阻。",
    "丙+辛": "代表背部不平、手术，小肠手术。",
    "丙+乙": "代表背部酸胀，消化不良。",
    "丁+丙": "代表指甲炎症。",
    "丁+丁": "代表指甲够有倒刺或炎症。",
    "丁+庚": "代表指骨折断或指尖疼痛。",
    "丁+癸": "代表指甲部位感染、溃烂。",
    "丁+己": "代表指尖有疣物或指甲部位麻木。",
    "丁+壬": "代表指骨错位。",
    "丁+戊": "代表指尖发麻。",
    "丁+辛": "代表指尖畸形。",
    "丁+乙": "代表指甲变形。",
    "庚+丙": "代表小手臂骨弯曲，扭伤，酸痛。",
    "庚+丁": "代表小手臂骨部位手术或有炎症。",
    "庚+庚": "代表小手臂折断或长藓或白斑。",
    "庚+癸": "代表小手臂骨长疮或感染发炎。",
    "庚+己": "代表小手臂长疮或长瘤。",
    "庚+壬": "代表小手臂骨错位或肿胀。",
    "庚+戊": "代表小手臂骨发麻。",
    "庚+辛": "代表小手臂骨裂或扭伤等。",
    "庚+乙": "代表小手臂骨弯曲，扭伤，酸痛。",
    "癸+丙": "代表手部有炎症。",
    "癸+丁": "代表手部有斑点状炎症。",
    "癸+庚": "代表手部硬皮症、白斑、癣。",
    "癸+癸": "代表手部湿疹、溃烂。",
    "癸+己": "代表手部生疮。",
    "癸+壬": "代表手部肿胀。",
    "癸+戊": "代表手部麻木。",
    "癸+辛": "代表手部有疣、瘊状物。",
    "癸+乙": "代表手部肌肉酸痛。",
    "己+丙": "代表脾出血，肠炎。",
    "己+丁": "代表脾出血，肠炎。",
    "己+庚": "代表脾病变，肠恶性病变，肠梗阻。",
    "己+己": "代表脾肿，肠粘连或肠套叠，肠蠕动慢。",
    "己+壬": "代表肠胀气，肠移位。",
    "己+戊": "代表脾肥大，肠蠕动慢。",
    "己+辛": "代表脾增生、肠梗阻。",
    "己+乙": "代表肠功能衰弱，消化不良等。",
    "壬+丙": "代表手臂肌肉发炎或烫伤烧伤等。",
    "壬+丁": "代表小手臂肌肉部位有炎症或烧烫伤，或被叮咬碰伤扎伤等。",
    "壬+庚": "代表小手臂肌肉部位有藓或白斑或肌肉坏死。",
    "壬+癸": "代表小手臂肌肉溃烂、湿疹等。",
    "壬+己": "代表小手臂部位长瘤或疮。",
    "壬+壬": "代表小手臂肌肉松弛、溃烂。",
    "壬+戊": "代表小手臂部位麻木等。",
    "壬+辛": "代表小手臂肌肉有颗粒，麻疹、疮、小型瘤等。",
    "壬+乙": "代表小手臂弯曲。",
    "戊+丙": "代表胃炎、胃出血。",
    "戊+丁": "代表浅表性胃炎。",
    "戊+庚": "代表胃有恶性病变。",
    "戊+癸": "代表胃溃疡、胃糜烂。",
    "戊+己": "代表为消化不良。",
    "戊+壬": "代表胃胀胃寒。",
    "戊+戊": "代表胃瘤，或胃动力不足。",
    "戊+辛": "代表胃部颗粒状炎症。",
    "戊+乙": "代表胃酸过多，胃胀。",
    "辛+丙": "代表手骨部位有炎症。",
    "辛+丁": "代表手骨部位有炎症。",
    "辛+庚": "代表手骨断裂、骨癌。",
    "辛+癸": "代表手骨部位溃烂。",
    "辛+己": "代表手骨增生，有炎症。",
    "辛+壬": "代表手骨错位或肿胀。",
    "辛+戊": "代表手骨神经失去知觉。",
    "辛+辛": "代表手骨增生。",
    "辛+乙": "代表手骨弯曲变形。",
    "乙+丙": "代表手烫伤、烧伤、炎症、肠炎。",
    "乙+丁": "代表手部长疣，也主烫烧伤，肠炎等。",
    "乙+庚": "代表手折断，手掌藓或白斑，肠部恶性疾病。",
    "乙+癸": "代表手部溃烂，肠炎等。",
    "乙+己": "代表手长疮、长瘤、肠梗阻。",
    "乙+壬": "代表手关节错位、酸胀、肠炎、消化不良。",
    "乙+戊": "代表手肥厚、手发麻、肠梗阻。",
    "乙+辛": "代表手上有疣物等颗粒状物，肠部做手术。",
    "乙+乙": "代表手关节酸痛，手关节变形，肠重叠。"
  },
  "震": {
    "丙+丙": "代表心肌炎。",
    "丙+丁": "代表心肌炎。",
    "丙+庚": "代表心肌梗塞。",
    "丙+癸": "代表心脏血液循环不畅。",
    "丙+己": "代表冠心病。",
    "丙+壬": "代表心脏移位。",
    "丙+戊": "代表心脏肥厚。",
    "丙+辛": "代表心脏瓣膜问题。",
    "丙+乙": "代表心脏动脉狭窄。",
    "丁+丙": "代表舌头发炎。",
    "丁+丁": "代表舌头有溃疡。",
    "丁+庚": "代表舌硬、舌癌。",
    "丁+癸": "代表舌溃疡。",
    "丁+己": "代表舌疮。",
    "丁+壬": "代表舌流血、舌肿。",
    "丁+戊": "代表舌苔增厚。",
    "丁+辛": "代表舌疮。",
    "丁+乙": "代表舌头中风，流口水。",
    "庚+丙": "代表肱骨炎。",
    "庚+丁": "代表肱骨炎症或手术。",
    "庚+庚": "代表肱骨折断或骨癌。",
    "庚+癸": "代表肱骨炎或错位。",
    "庚+己": "代表肱骨骨髓炎。",
    "庚+壬": "代表肱骨错位。",
    "庚+戊": "代表肱骨麻木。",
    "庚+辛": "代表肱骨手术或劈裂。",
    "庚+乙": "代表肱骨弯曲、肋骨畸形。",
    "癸+丙": "代表血管炎，神经炎。",
    "癸+丁": "代表血管堵塞、血管炎神经炎。",
    "癸+庚": "代表血管杜塞，硬化神经坏死。",
    "癸+癸": "代表血液不干净。",
    "癸+己": "代表血管壁杜塞或神经麻痹。",
    "癸+壬": "代表血液膨胀。",
    "癸+戊": "代表血管壁厚、神经麻痹。",
    "癸+辛": "代表血脂高等。",
    "癸+乙": "代表血管缠绕、或神经缠绕。",
    "己+丙": "代表腹部、脾脏有炎症。",
    "己+丁": "代表腹部、脾脏手术或炎症。",
    "己+庚": "代表脾裂或腹部白斑、腹癣。",
    "己+癸": "代表腹部溃疡。",
    "己+己": "代表腹部瘤、脾瘤、疮。",
    "己+壬": "代表脾移位。",
    "己+戊": "代表腹部、脾脏肥大。",
    "己+辛": "代表腹部湿疹。",
    "己+乙": "代表腹部、脾脏不适。",
    "壬+丙": "代表胳膊发炎。",
    "壬+丁": "代表胳膊手术或发炎。",
    "壬+庚": "代表胳膊肩臂肌肉萎缩、僵硬、湿疹白斑等。",
    "壬+癸": "代表胳膊溃烂。",
    "壬+己": "代表胳膊生疮生瘤。",
    "壬+壬": "代表胳膊肿胀。",
    "壬+戊": "代表胳膊麻木。",
    "壬+辛": "代表胳膊肌肉拉伤或手术。",
    "壬+乙": "代表胳膊酸痛。",
    "戊+丙": "代表乳腺炎。",
    "戊+丁": "代表乳腺增生。",
    "戊+庚": "代表乳房肿块。",
    "戊+癸": "代表乳房湿疹或感染。",
    "戊+己": "代表乳房瘤。",
    "戊+壬": "代表乳房肿胀。",
    "戊+戊": "代表乳房肥大。",
    "戊+辛": "代表乳房结节。",
    "戊+乙": "代表乳房胀痛。",
    "辛+丙": "代表肋骨膜炎。",
    "辛+丁": "代表肋部手术、肋膜炎。",
    "辛+庚": "代表肋折断、肋骨癌。",
    "辛+癸": "代表肋疮等。",
    "辛+己": "代表肋疮。",
    "辛+壬": "代表肋骨错位。",
    "辛+戊": "代表肋神经麻木。",
    "辛+辛": "代表肋劈裂。",
    "辛+乙": "代表肋骨畸形。",
    "乙+丙": "代表肝炎、胆囊炎。",
    "乙+丁": "代表肝炎、胆囊炎、胆结石等。",
    "乙+庚": "代表肝硬化，胆结石。",
    "乙+癸": "代表肝附水，胆积液等。",
    "乙+己": "代表脂肪肝，胆壁增厚，呼吸道堵了。",
    "乙+壬": "代表肝附水，胆汁排不出。",
    "乙+戊": "代表脂肪肝、胆壁增厚。",
    "乙+辛": "代表肝损伤，胆结石。",
    "乙+乙": "代表胆管狭窄。"
  },
  "巽": {
    "丙+丙": "代表眼部红肿有炎症。",
    "丙+丁": "代表眼红、炎症（多为麦粒肿）等。",
    "丙+庚": "代表眼睛严重视力障碍。",
    "丙+癸": "代表眼部感染或溃烂。",
    "丙+己": "代表眼部有疮痂或瘤或眼部肿大等。",
    "丙+壬": "代表眼部水肿。",
    "丙+戊": "代表眼部肥厚肿大等。",
    "丙+辛": "代表眼部有增生物等。",
    "丙+乙": "代表眼部中风或鱼尾纹多。",
    "丁+丙": "代表牙龈出血。",
    "丁+丁": "代表牙结石或牙有炎症。",
    "丁+庚": "代表牙结石或口腔病变。",
    "丁+癸": "代表牙龈感染。",
    "丁+己": "代表牙龋齿。",
    "丁+壬": "代表牙龈出血。",
    "丁+戊": "代表牙龈肿。",
    "丁+辛": "代表牙结石。",
    "丁+乙": "代表牙齿不齐。",
    "庚+丙": "代表肩胛骨炎症。",
    "庚+丁": "代表肩胛骨炎症。",
    "庚+庚": "代表肩胛骨断裂。",
    "庚+癸": "代表肩胛骨炎症。",
    "庚+己": "代表肩胛骨结核。",
    "庚+壬": "代表肩胛骨错位。",
    "庚+戊": "代表肩胛骨肥大。",
    "庚+辛": "代表肩胛骨劈裂。",
    "庚+乙": "代表肩胛骨畸形。",
    "癸+丙": "代表锁骨下静脉炎症。",
    "癸+丁": "代表锁骨下静脉炎症或杜塞。",
    "癸+庚": "代表锁骨下静脉硬化或阻塞。",
    "癸+癸": "代表锁骨下静脉血管炎症。",
    "癸+己": "代表锁骨下静脉管壁流血不畅。",
    "癸+壬": "代表锁骨下静脉血管膨胀。",
    "癸+戊": "代表锁骨下静脉管壁增厚。",
    "癸+辛": "代表锁骨下静脉硬化。",
    "癸+乙": "代表锁骨下静脉狭窄。",
    "己+丙": "代表三角肌发炎红肿。",
    "己+丁": "代表三角肌长疮或手术。",
    "己+庚": "代表三角肌萎缩、硬化、或长癣。",
    "己+癸": "代表三角肌湿疹或疮疖。",
    "己+己": "代表三角肌长疮或瘤。",
    "己+壬": "代表三角肌胀痛。",
    "己+戊": "代表三角肌肥厚或麻木。",
    "己+辛": "代表三角肌湿疹或长癣疥。",
    "己+乙": "代表三角肌酸胀。",
    "壬+丙": "代表锁骨下动脉炎症。",
    "壬+丁": "代表锁骨下动脉炎症或杜塞。",
    "壬+庚": "代表锁骨下动脉硬化或阻塞。",
    "壬+癸": "代表锁骨下动脉血管炎症。",
    "壬+己": "代表锁骨下动脉管壁流血不畅。",
    "壬+壬": "代表锁骨下动脉血管膨胀。",
    "壬+戊": "代表锁骨下动脉管壁增厚。",
    "壬+辛": "代表锁骨下动脉硬化。",
    "壬+乙": "代表锁骨下动脉狭窄。",
    "戊+丙": "代表胸大肌发炎红肿。",
    "戊+丁": "代表胸大肌长疮或手术。",
    "戊+庚": "代表胸大肌萎缩、硬化或长癣。",
    "戊+癸": "代表胸大肌湿疹或疮疖。",
    "戊+己": "代表胸大肌长疮或瘤。",
    "戊+壬": "代表胸大肌胀痛。",
    "戊+戊": "代表胸大肌肥厚或麻木。",
    "戊+辛": "代表胸大肌湿疹或长癣疥。",
    "戊+乙": "代表胸大肌酸胀。",
    "辛+丙": "代表锁骨炎症。",
    "辛+丁": "代表锁骨炎症。",
    "辛+庚": "代表锁骨断裂。",
    "辛+癸": "代表锁骨炎症。",
    "辛+己": "代表锁骨结核。",
    "辛+壬": "代表锁骨错位。",
    "辛+戊": "代表锁骨肥大。",
    "辛+辛": "代表锁骨劈裂。",
    "辛+乙": "代表肩胛骨畸形。",
    "乙+丙": "代表胆管发炎，气管炎，食道发炎，神经发炎，血管炎，大腿部红肿，肠炎等。",
    "乙+丁": "代表胆管炎症或杜塞，气管、食道局部发炎、神经炎，血管炎肠炎大腿部红肿，脖子长疔。",
    "乙+庚": "代表胆恶性病变，气管、食道、血管、肠等恶性病变，神经麻痹，股部断裂等。",
    "乙+癸": "代表胆汁排泄不畅，肝腹水，气管、食道溃烂，血管中血脂高、胆固醇高凳，股部溃烂肠炎等。",
    "乙+己": "代表胆有息肉或瘤状物，气管食道有异物，神经麻痹，血管壁增厚或瘤，股部瘤疮等，脖子长瘤子。",
    "乙+壬": "代表胆管梗阻，气管、食道溃烂出血，血管破裂，肠部积水，股部水肿等，肝腹水。",
    "乙+戊": "代表胆息肉，但比增厚，气管食管瘤，神经麻痹，血管瘤，腿部肉厚或瘤，肠蠕动慢。",
    "乙+辛": "代表胆结石，肠梗阻，气管、食道、神经炎症，腿部手术等。",
    "乙+乙": "代表胆管变细，食道不畅，神经错乱，血管缠绕或血流不畅，大腿弯曲，肠功能障碍，脖子扭了。"
  },
  "离": {
    "丙+丙": "代表眼睛红肿或嘴巴发炎。",
    "丙+丁": "代表眼睛长疔或嘴巴长疔。",
    "丙+庚": "代表眼白内障或眼盲，嘴巴不说话或爱教训人。",
    "丙+癸": "代表眼部嘴部长疮或溃烂。",
    "丙+己": "代表眼部、嘴巴。",
    "丙+壬": "代表眼流泪或口流涎。",
    "丙+戊": "代表眼睛肿大或嘴唇厚。",
    "丙+辛": "代表眼睛视力差或有病，嘴巴兔唇或有病或说胡话。",
    "丙+乙": "代表嘴歪或眼斜。",
    "丁+丙": "代表心肌炎。",
    "丁+丁": "代表心肌梗塞。",
    "丁+庚": "代表心脏受阻，停止跳动。",
    "丁+癸": "代表心脏跳动缓慢。",
    "丁+己": "代表心脏肥大。",
    "丁+壬": "代表心脏血压高。",
    "丁+戊": "代表心脏肥大。",
    "丁+辛": "代表心率不齐或心率过速等。",
    "丁+乙": "代表冠心病。",
    "庚+丙": "代表头骨大面积受伤。",
    "庚+丁": "代表头骨受伤。",
    "庚+庚": "代表头骨骨折。",
    "庚+癸": "代表头骨错位。",
    "庚+己": "代表头部长疮或长瘤。",
    "庚+壬": "代表头骨错位。",
    "庚+戊": "代表头骨发麻。",
    "庚+辛": "代表头部被小型器皿所伤。",
    "庚+乙": "代表头骨不正。",
    "癸+丙": "代表脑静脉出血或炎症。",
    "癸+丁": "代表脑静脉血栓或炎症。",
    "癸+庚": "代表脑静脉梗塞。",
    "癸+癸": "代表脑静脉出血。",
    "癸+己": "代表脑动脉粥样硬化或瘤。",
    "癸+壬": "代表脑静脉出血。",
    "癸+戊": "代表脑静脉粥样硬化。",
    "癸+辛": "代表脑静脉堵塞。",
    "癸+乙": "代表脑静脉流血不畅。",
    "己+丙": "代表脑炎。",
    "己+丁": "代表脑出血。",
    "己+庚": "代表脑梗塞。",
    "己+癸": "代表脑栓塞。",
    "己+己": "代表脑瘤。",
    "己+壬": "代表脑出血。",
    "己+戊": "代表脑痴呆。",
    "己+辛": "代表脑血栓。",
    "己+乙": "代表脑中风。",
    "壬+丙": "代表脑动脉出血或炎症。",
    "壬+丁": "代表脑动脉血栓或炎症。",
    "壬+庚": "代表脑动脉梗塞。",
    "壬+癸": "代表脑动脉出血。",
    "壬+己": "代表脑动脉粥样硬化或瘤。",
    "壬+壬": "代表脑动脉出血。",
    "壬+戊": "代表脑动脉粥样硬化。",
    "壬+辛": "代表脑动脉堵塞。",
    "壬+乙": "代表脑动脉流血不畅。",
    "戊+丙": "代表脑炎。",
    "戊+丁": "代表脑出血。",
    "戊+庚": "代表脑梗塞。",
    "戊+癸": "代表脑栓塞。",
    "戊+己": "代表脑瘤。",
    "戊+壬": "代表脑出血。",
    "戊+戊": "代表脑痴呆。",
    "戊+辛": "代表脑血栓。",
    "戊+乙": "代表脑中风。",
    "辛+丙": "代表颈椎炎症等。",
    "辛+丁": "代表颈椎骨质增生。",
    "辛+庚": "代表颈椎折断。",
    "辛+癸": "代表颈椎错位。",
    "辛+己": "代表颈椎狭窄。",
    "辛+壬": "代表颈椎错位。",
    "辛+戊": "代表颈椎麻木。",
    "辛+辛": "代表颈椎有骨刺。",
    "辛+乙": "代表颈椎弯曲等。",
    "乙+丙": "代表脑神经炎，耳朵炎症。",
    "乙+丁": "代表脑血管堵塞。",
    "乙+庚": "代表脑神经痛。",
    "乙+癸": "代表脑神经胀痛；乙+癸+杜门，脑血栓（三七宫逢白虎、庚、引干有乙，胳膊不能动，肯定是脑血栓）。",
    "乙+己": "代表脑神经错乱。",
    "乙+壬": "代表脑神经胀痛。",
    "乙+戊": "代表脑神经麻痹。",
    "乙+辛": "代表脑神经错乱。",
    "乙+乙": "代表脑血管狭窄，或者神经有问题。"
  },
  "坤": {
    "丙+丙": "代表贲门或幽门部位有炎症。",
    "丙+丁": "代表贲门或幽门部位出现颗粒状炎症。",
    "丙+庚": "代表贲门或幽门部位恶性病变。",
    "丙+癸": "代表贲门或幽门部位溃烂。",
    "丙+己": "代表贲门或幽门部位溃烂。",
    "丙+壬": "代表贲门或幽门部位涨满。",
    "丙+戊": "代表贲门或幽门部位增厚、堵塞。",
    "丙+辛": "代表贲门或幽门部位出现颗粒状炎症。",
    "丙+乙": "代表贲门或幽门部位狭窄。",
    "丁+丙": "代表肚脐部位有炎症。",
    "丁+丁": "代表肚脐部位长有粉刺、疮痂或炎症。",
    "丁+庚": "代表脐部萎缩，脐部长癣或出现白斑等。",
    "丁+癸": "代表脐部湿疹、溃烂。",
    "丁+己": "代表肚脐部位溃烂疮瘤。",
    "丁+壬": "代表脐部涨满。",
    "丁+戊": "代表肚脐部位肥大、脐部麻胀不适。",
    "丁+辛": "代表脐部麻疹、有颗粒状物质。",
    "丁+乙": "代表肚脐部位酸痛。",
    "庚+丙": "代表胸椎炎。",
    "庚+丁": "代表胸椎有增生物或炎症。",
    "庚+庚": "代表胸椎部恶性病变，胸椎骨伤。",
    "庚+癸": "代表胸椎部炎症。",
    "庚+己": "代表胸椎部增生，或胸骨瘤。",
    "庚+壬": "代表胸椎部错位。",
    "庚+戊": "代表胸椎部麻木或肥大。",
    "庚+辛": "代表胸椎有增生物或手术。",
    "庚+乙": "代表胸椎弯曲。",
    "癸+丙": "代表腹腔静脉出血或炎症。",
    "癸+丁": "代表腹腔静脉堵塞或炎症。",
    "癸+庚": "代表腹腔静脉受阻。",
    "癸+癸": "代表腹腔静脉出血。",
    "癸+己": "代表腹腔静脉瘤或流血不畅。",
    "癸+壬": "代表腹腔静脉出血。",
    "癸+戊": "代表腹腔静脉管壁增厚或流血不畅。",
    "癸+辛": "代表腹腔静脉有血栓等。",
    "癸+乙": "代表腹腔静脉血流不畅。",
    "己+丙": "代表小腹刺痒，肠炎，女性生殖器红肿。",
    "己+丁": "代表小腹、女性生殖器有水泡湿疹。",
    "己+庚": "代表小腹白斑、癣疥。女性生殖器念珠菌、或恶性病变。",
    "己+癸": "代表女性外阴部、小腹部湿疹或溃烂。",
    "己+己": "代表腹部生疮，女性生殖器增生物。",
    "己+壬": "代表小腹胀痛、女性外阴出血。",
    "己+戊": "代表小腹肥厚，麻胀，女性生殖器增生物。",
    "己+辛": "代表小腹不平有疤痕，女性生殖器湿疹、颗粒状物。",
    "己+乙": "代表小腹酸痛、女性生殖器畸形。",
    "壬+丙": "代表腹腔动脉出血或炎症。",
    "壬+丁": "代表腹腔动脉堵塞或炎症。",
    "壬+庚": "代表腹腔动脉受阻。",
    "壬+癸": "代表腹腔动脉出血。",
    "壬+己": "代表腹腔动脉瘤或流血不畅。",
    "壬+壬": "代表腹腔动脉出血。",
    "壬+戊": "代表腹腔动脉管壁增厚或流血不畅。",
    "壬+辛": "代表腹腔动脉有血栓等。",
    "壬+乙": "代表腹腔动脉血流不畅。",
    "戊+丙": "代表胃炎。",
    "戊+丁": "代表胃浅表性胃炎。",
    "戊+庚": "代表为恶性病变。",
    "戊+癸": "代表胃溃疡或胃出血。",
    "戊+己": "代表胃积石或胃瘤。",
    "戊+壬": "代表胃胀满或胃出血。",
    "戊+戊": "代表胃蠕动能力差。",
    "戊+辛": "代表为胃有颗粒状炎症或手术。",
    "戊+乙": "代表胃痉挛、胃痛。",
    "辛+丙": "代表胸骨炎。",
    "辛+丁": "代表胸骨有增生物或炎症。",
    "辛+庚": "代表胸骨部恶性病变，胸骨骨伤。",
    "辛+癸": "代表胸骨部炎症。",
    "辛+己": "代表胸骨部增生，或胸骨瘤。",
    "辛+壬": "代表胸骨部错位。",
    "辛+戊": "代表胸骨部麻木或肥大。",
    "辛+辛": "代表胸骨有增生物或手术。",
    "辛+乙": "代表胸骨弯曲。",
    "乙+丙": "代表食道烫伤、食道炎症等。",
    "乙+丁": "代表食道扎伤或发炎等。",
    "乙+庚": "代表食道癌等。",
    "乙+癸": "代表食道出血。",
    "乙+己": "代表食道生疮。",
    "乙+壬": "代表食道出血。",
    "乙+戊": "代表食道麻痹。",
    "乙+辛": "代表食道有炎症或咽炎等。",
    "乙+乙": "代表食道不畅，十二指肠蠕动慢，颈部神经缠绕等。"
  },
  "兑": {
    "丙+丙": "代表支气管炎。",
    "丙+丁": "代表支气管炎。",
    "丙+庚": "代表气管部位受阻或呼吸困难或恶性病变。",
    "丙+癸": "代表支气管炎、痰阻。",
    "丙+己": "代表气管瘤或增生物。",
    "丙+壬": "代表支气管水肿。",
    "丙+戊": "代表代表支气管增生物。",
    "丙+辛": "代表气管部位炎症、痰鸣。",
    "丙+乙": "代表气管狭窄。",
    "丁+丙": "代表口腔炎，舌肿大，牙龈炎。",
    "丁+丁": "代表口舌生疮，牙龈肿痛。",
    "丁+庚": "代表口腔恶性病变。",
    "丁+癸": "代表口腔溃烂或出血。",
    "丁+己": "代表口腔溃疡，牙龈炎。",
    "丁+壬": "代表口腔出血。",
    "丁+戊": "代表嘴肿大，舌苔厚，牙龈肿。",
    "丁+辛": "代表嘴部湿疹，舌部溃疡或颗粒状炎症，牙结石。",
    "丁+乙": "代表嘴不正或中风，说话不利落，牙齿不齐。",
    "庚+丙": "代表左上支气管炎症。",
    "庚+丁": "代表左上支气管炎。",
    "庚+庚": "代表左上支气管部位受阻或呼吸困难或恶性病变。",
    "庚+癸": "代表左上支气管炎、痰阻。",
    "庚+己": "代表左上支气管瘤或增生物。",
    "庚+壬": "代表左上支气管水肿。",
    "庚+戊": "代表左上支气管增生物。",
    "庚+辛": "代表左上支气管部位炎症、痰鸣。",
    "庚+乙": "代表左上支气管狭窄。",
    "癸+丙": "代表肺静脉炎症。",
    "癸+丁": "代表肺静脉炎症。",
    "癸+庚": "代表肺静脉部恶性病变。",
    "癸+癸": "代表肺静脉部血流迟滞。",
    "癸+己": "代表肺静脉瘤或增生物。",
    "癸+壬": "代表肺静脉部血流受阻。",
    "癸+戊": "代表肺静脉循环阻碍。",
    "癸+辛": "代表肺静脉部瘤状物。",
    "癸+乙": "代表肺静脉循环不畅。",
    "己+丙": "代表肺下叶炎症。",
    "己+丁": "代表肺下叶有钙化点或炎症。",
    "己+庚": "代表肺下叶有恶性病变。",
    "己+癸": "代表肺下叶有积水。",
    "己+己": "代表肺下叶有结核或瘤状物。",
    "己+壬": "代表肺下叶积水。",
    "己+戊": "代表肺下叶肥厚或肿大。",
    "己+辛": "代表肺下叶有结核或钙化点。",
    "己+乙": "代表肺下叶扩张困难。",
    "壬+丙": "代表肺动脉炎症。",
    "壬+丁": "代表肺动脉炎症。",
    "壬+庚": "代表肺动脉部恶性病变。",
    "壬+癸": "代表肺动脉部血流迟滞。",
    "壬+己": "代表肺动脉瘤或增生物。",
    "壬+壬": "代表肺动脉部血流受阻。",
    "壬+戊": "代表肺动脉循环阻碍。",
    "壬+辛": "代表肺动脉部瘤状物。",
    "壬+乙": "代表肺动脉循环不畅。",
    "戊+丙": "代表肺上叶炎症。",
    "戊+丁": "代表肺上叶有钙化点或炎症。",
    "戊+庚": "代表肺上叶有恶性病变。",
    "戊+癸": "代表肺上叶有积水。",
    "戊+己": "代表肺上叶有结核或瘤状物。",
    "戊+壬": "代表肺上叶积水。",
    "戊+戊": "代表肺上叶肥厚或肿大。",
    "戊+辛": "代表肺上叶有结核或钙化点。",
    "戊+乙": "代表肺上叶扩张困难。",
    "辛+丙": "代表下支气管炎。",
    "辛+丁": "代表下支气管炎。",
    "辛+庚": "代表下支气管部位受阻或呼吸困难或恶性病变。",
    "辛+癸": "代表下支气管炎、痰阻。",
    "辛+己": "代表下支气管瘤或增生物。",
    "辛+壬": "代表下支气管水肿。",
    "辛+戊": "代表下支气管增生物。",
    "辛+辛": "代表下支气管部位炎症、痰鸣。",
    "辛+乙": "代表下支气管狭窄。",
    "乙+丙": "代表气管炎。",
    "乙+丁": "代表气管炎。",
    "乙+庚": "代表气管部位受阻或呼吸困难或恶性病变。",
    "乙+癸": "代表支气管炎、痰阻。",
    "乙+己": "代表气管瘤或增生物。",
    "乙+壬": "代表支气管水肿。",
    "乙+戊": "代表气管增生物。",
    "乙+辛": "代表气管部位炎症、痰鸣。",
    "乙+乙": "代表气管狭窄。"
  }
};
